import { useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { useAppDispatch } from '@/state'

import { ApplicationState } from '@/state/root.models'
import {
  Excluded,
  ExcludedGamesType,
  GetExcludedGamesPayload,
  GetGamesListPayload,
  SaveExcludedGamesPayload,
} from '@/state/excluded-games/models'
import { getExcludedGamesThunk } from '@/state/excluded-games/thunks/get-excluded-games.thunk'

import { saveExcludedGamesThunk } from '@/state/excluded-games/thunks/save-excluded-games.thunk'
import { getAllGamesThunk } from '@/state/excluded-games/thunks/get-all-games.thunk'
import { ExcludedGamesActions } from '@/state/excluded-games/slices/index.slices'

import { resetGamesList } from '@/state/wagering-contribution/slices/index.slices'

export const useExcludedGamesActions = () => {
  const { excludedGames } = useSelector(
    ({ excludedGames }: ApplicationState) => excludedGames,
  )

  const dispatch = useAppDispatch()

  const getExcludedGames = debounce(
    (payload: GetExcludedGamesPayload) => {
      dispatch(
        getExcludedGamesThunk({
          ...payload,
        }),
      )
    },
    500, // eslint-disable-line
  )

  const getAllGames = debounce(
    (payload: GetGamesListPayload) => {
      dispatch(getAllGamesThunk(payload))
    },
    500, // eslint-disable-line
  )

  const saveExcludedGames = debounce(
    (payload: SaveExcludedGamesPayload) => {
      dispatch(saveExcludedGamesThunk({ ...payload }))
    },
    500, // eslint-disable-line
  )

  const resetGamesListAction = () => {
    dispatch(resetGamesList())
  }

  const deleteExcludedGames = debounce(
    (gameId: string, gameProviderId: string) => {
      const saveExcludedGamesList: Excluded[] = []

      excludedGames.games
        .filter(
          (item: Excluded) =>
            item.gameId.toString() !== gameId &&
            item.gameProviderId.toString() !== gameProviderId,
        )
        .forEach((excluded: Excluded) => {
          const wageringItem = {
            gameId: excluded.gameId,
            gameProviderId: excluded.gameProviderId,
            gameDescription: excluded.gameDescription,
            isBlocked: excluded.isBlocked,
          }
          saveExcludedGamesList.push(wageringItem)
        })

      dispatch(
        saveExcludedGamesThunk({
          _id: excludedGames._id,
          name: excludedGames.name,
          games: saveExcludedGamesList,
        }),
      )
    },
    500, // eslint-disable-line
  )

  const setExcludedGames = debounce(
    (payload: ExcludedGamesType) => {
      dispatch(ExcludedGamesActions.setExcludedGamesAction(payload))
    },
    500, // eslint-disable-line
  )

  const setCurrentGame = debounce((payload?: Excluded) => {
    dispatch(ExcludedGamesActions.setCurrentGameAction(payload || null))
  })

  return {
    getExcludedGames,
    getAllGames,
    setExcludedGames,
    saveExcludedGames,
    deleteExcludedGames,
    setCurrentGame,
    resetGamesListAction,
  }
}
